(() => {
  if (window.DiggnInventoryScarcityTest?.initialized) return;
  window.DiggnInventoryScarcityTest = { initialized: true };

  const ARM_STORAGE_KEY = 'dg_inventory_scarcity_arm_v1';
  const CART_SYNC_STORAGE_KEY = 'dg_inventory_scarcity_cart_sync_v1';
  const EXPOSURE_EVENT = 'diggnit_inventory_scarcity_exposure';
  const CONTROL_ARM = 'control';
  const TREATMENT_ARM = 'treatment';
  const exposed = new Set();

  const analyticsAllowed = () => {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    } catch {
      return false;
    }
  };

  const assignArm = () => {
    try {
      const storedArm = window.sessionStorage.getItem(ARM_STORAGE_KEY);
      if (storedArm === CONTROL_ARM || storedArm === TREATMENT_ARM) return storedArm;
    } catch {
      // Continue with an in-memory assignment when session storage is unavailable.
    }

    const assignedArm = Math.random() < 0.5 ? CONTROL_ARM : TREATMENT_ARM;
    try {
      window.sessionStorage.setItem(ARM_STORAGE_KEY, assignedArm);
    } catch {
      // The in-memory assignment still keeps this page view consistent.
    }
    return assignedArm;
  };

  const arm = assignArm();
  document.documentElement.dataset.dgInventoryScarcityArm = arm;

  const exposureDetail = (root, message) => ({
    experiment_id: root.dataset.diggnInventoryScarcityExperiment || 'pdp_low_stock_v1',
    arm,
    product_handle: root.dataset.diggnInventoryScarcityProduct || null,
    variant_id: message.dataset.variantId || null,
    inventory_quantity: Number(message.dataset.inventoryQuantity),
    inventory_threshold: Number(message.dataset.inventoryThreshold),
    language: document.documentElement.lang || null,
    page_path: window.location.pathname,
  });

  const publishExposure = (detail) => {
    if (!analyticsAllowed()) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: EXPOSURE_EVENT, ...detail });
    try {
      window.Shopify?.analytics?.publish?.(EXPOSURE_EVENT, detail);
    } catch {
      // Keep the buying journey intact when Customer Events is unavailable.
    }
    document.dispatchEvent(new CustomEvent('diggn:track', {
      detail: { event: EXPOSURE_EVENT, ...detail },
    }));
  };

  const syncCartExperiment = (detail) => {
    if (!analyticsAllowed()) return;

    const attributes = {
      dg_scarcity_test__: detail.experiment_id,
      dg_scarcity_arm__: detail.arm,
      dg_scarcity_product__: detail.product_handle || '',
      dg_scarcity_variant__: detail.variant_id || '',
      dg_scarcity_quantity__: String(detail.inventory_quantity),
    };
    const signature = JSON.stringify(attributes);

    try {
      if (window.sessionStorage.getItem(CART_SYNC_STORAGE_KEY) === signature) {
        document.documentElement.dataset.dgInventoryScarcityCartSync = 'cached';
        return;
      }
    } catch {
      // Continue with Shopify's cart endpoint when storage is unavailable.
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes }),
      credentials: 'same-origin',
      keepalive: true,
    }).then((response) => {
      if (!response.ok) throw new Error(`scarcity test cart sync failed (${response.status})`);
      try {
        window.sessionStorage.setItem(CART_SYNC_STORAGE_KEY, signature);
      } catch {
        // Shopify already received the assignment.
      }
      document.documentElement.dataset.dgInventoryScarcityCartSync = 'ok';
    }).catch(() => {
      document.documentElement.dataset.dgInventoryScarcityCartSync = 'error';
      // Never interrupt checkout when experiment attribution is unavailable.
    });
  };

  const syncRoot = (root) => {
    root.dataset.diggnInventoryScarcityArm = arm;
    const message = root.querySelector('[data-diggn-inventory-scarcity-message]');
    const shouldShow = arm === TREATMENT_ARM && Boolean(message);

    root.hidden = !shouldShow;
    root.classList.toggle('hidden', !shouldShow);

    if (!message) return;

    const detail = exposureDetail(root, message);
    const exposureKey = `${detail.experiment_id}:${detail.variant_id}:${detail.arm}`;
    if (exposed.has(exposureKey) || !analyticsAllowed()) return;

    exposed.add(exposureKey);
    publishExposure(detail);
    syncCartExperiment(detail);
  };

  const syncAll = (scope = document) => {
    scope.querySelectorAll('[data-diggn-inventory-scarcity]').forEach(syncRoot);
  };

  const init = () => {
    syncAll();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = event?.data?.sectionId;
        const root = sectionId ? document.getElementById(`Inventory-${sectionId}`) : null;
        if (root?.matches('[data-diggn-inventory-scarcity]')) syncRoot(root);
      });
    }

    document.addEventListener('shopify:section:load', (event) => syncAll(event.target));
    document.addEventListener('visitorConsentCollected', () => syncAll());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
